const breakpoint = 768;

const fadeInUp = () => {
  const targets = document.querySelectorAll('.js-fadeInUp');
  targets.forEach((target) => {
    gsap.fromTo(target,
      {
        y: 30,
        autoAlpha: 0,
      },
      {
        y: 0,
        autoAlpha: 1,
        duration: 0.8,
        ease: "power1.out",
        scrollTrigger: {
          trigger: target,
          start: 'top 90%',
        }
      }
    );
  });
};

const fadeIn = () => {
  const targets = document.querySelectorAll('.js-fadeIn');
  targets.forEach((target) => {
    gsap.fromTo(target,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.9,
        ease: "power1.out",
        scrollTrigger: {
          trigger: target,
          start: 'top 90%',
        }
      }
    );
  });
};

const drawLine = () => {
  const svgs = document.querySelectorAll('.js-drawLine');
  svgs.forEach((svg) => {
    const path = svg.querySelector('path');
    if (!path) return;

    const length = path.getTotalLength();

    gsap.set(path, {
      strokeDasharray: length,
      strokeDashoffset: length,
    });

    gsap.set(svg, { visibility: 'visible' });

    gsap.to(path, {
      strokeDashoffset: 0,
      ease: "none",
      scrollTrigger: {
        trigger: svg,
        start: 'top 60%',
        end: 'bottom center',
        scrub: 1,
      }
    });
  });
};

const fadeInStagger = () => {
  const containers = document.querySelectorAll('.js-fadeInStagger');
  containers.forEach((container) => {
    const items = container.querySelectorAll('.js-fadeInStaggerItem');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: 'top 85%',
      }
    });

    tl.fromTo(container,
      {
        y: 30,
        autoAlpha: 0,
      },
      {
        y: 0,
        autoAlpha: 1,
        duration: 0.7,
        ease: "power1.out",
      }
    );

    if (items.length > 0) {
      tl.fromTo(items,
        {
          y: 20,
          autoAlpha: 0,
        },
        {
          y: 0,
          autoAlpha: 1,
          duration: 0.55,
          stagger: 0.09,
          ease: "power1.out",
        },
        "-=0.3"
      );
    }
  });
};

document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const mm = gsap.matchMedia();

  mm.add(`screen and (max-width: ${breakpoint - 1}px)`, () => {
    fadeInUp();
    fadeIn();
    fadeInStagger();
    drawLine();
  });
  mm.add(`screen and (min-width: ${breakpoint}px)`, () => {
    fadeInUp();
    fadeIn();
    fadeInStagger();
    drawLine();
  });
});

window.addEventListener('pageshow', function (event) {
  if (!event.persisted) return;

  var fadeSelector = [
    '.js-fadeIn',
    '.js-fadeInUp',
    '.js-fadeInLeft',
    '.js-fadeInRight',
    '.js-fadeInStagger',
    '.js-fadeInStaggerItem'
  ].join(',');

  document.querySelectorAll(fadeSelector).forEach(function (el) {
    el.style.opacity = '1';
    el.style.visibility = 'visible';
    el.style.transform = '';
    el.style.translate = '';
  });

  document.querySelectorAll('.js-drawLine').forEach(function (svg) {
    svg.style.visibility = 'visible';
    var path = svg.querySelector('path');
    if (path) {
      path.style.strokeDashoffset = '0';
    }
  });

  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.refresh();
  }
});
